import React, { useState, useEffect } from 'react'
import { encodeForURL } from '../../../global/formatters/string-formatter.js'
import * as StringFormatter from '../../../global/formatters/string-formatter.js'
import { getRelativeBasePath } from '../../../global/environments/path.js'

import Loader from '../../FundDetails/Modules/Shared/Loader.jsx'

import {
  updateArray,
  lookupIcon,
  lookupCategory,
  hasFundDistributionsEstimates,
  formatToFixed,
  isPresentFundEstimates,
} from '../Helpers/MutualFundsUtility'

import FilterHeader from '../../PageHeader/FilterHeader.jsx'
import MutualFundsFilter from './MutualFundsFilter.jsx'
import DOMPurify from 'dompurify'

export default function MutualFunds({
  getData,
  getMetadata,
  getDownload,
  getDownloadCapGains,
  rootNode,
  aspects,
  searchPlaceholder,
  strategyPlaceholder,
  ignoreClass,
  performanceOptions,
  classOptions,
  morningstarOptions,
  onChangeSection,
  parseData,
}) {
  const DEFAULT_CLASS = 'Institutional'

  const EMPTY_COMPONENT = () => <></>

  const urlSearchParams = new URLSearchParams(window.location.search)

  const ClassOptions = classOptions || EMPTY_COMPONENT
  const PerformanceOptions = performanceOptions
  const MorningstarOptions = morningstarOptions

  const [classes, setClasses] = useState()
  const [fundRoot, setFundRoot] = useState({})
  const [funds, setFunds] = useState([])
  const [fundsFiltered, setFundsFiltered] = useState([])
  const [selectedSection, setSelectedSection] = useState('#performance')
  const [selectedFundSearch, setFundSearch] = useState('')
  const [selectedClass, setSelectedClass] = useState()
  const [selectedPerformanceType, setSelectedPerformanceType] = useState('nav')
  const [selectedPerformanceFrequency, setSelectedPerformanceFrequency] =
    useState('Monthly')
  const [selectedDisplayBenchmark, setSelectedDisplayBenchmark] =
    useState(false)
  const [selectedDisplayMorningstar, setSelectedDisplayMorningstar] =
    useState(false)
  const [selectedDisplayMorningstarGroup, setSelectedDisplayMorningstarGroup] =
    useState(false)
  const [collapsedManagementStyleGroups, setCollapsedManagementStyleGroups] =
    useState([])
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [isFilterOn, setIsFilterOn] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState({})
  const [selectedFilterCount, setSelectedFilterCount] = useState(0)
  const [selectedSort, setSelectedSort] = useState(
    ignoreClass ? 'symbol' : 'fundName'
  )
  const [selectedSortDirection, setSelectedSortDirection] = useState(true)
  const [selectedSortType, setSelectedSortType] = useState('string')
  const [selectedGroups, setSelectedGroups] = useState([])
  const [isExpanded, setIsExpanded] = useState(false)
  const [isExpandable, setIsExpandable] = useState(false)
  const [isDataLoading, setIsDataLoading] = useState(true)
  const [isETF, setIsETF] = useState(false)
  const [isInitialLoad, setIsInitialLoad] = useState(true)

  const getAspect = (section) => {
    const _aspects = [
      {
        name: '#performance',
        info: {
          tag: selectedPerformanceFrequency,
          selector: [
            {
              name: 'performanceFunds',
              isArray: false,
            },
          ],
          renderOptions: () => {
            return (
              <>
                {
                  <>
                    <ClassOptions
                      defaultClassName={DEFAULT_CLASS}
                      selectedClass={selectedClass}
                      classes={classes}
                      onChangeFundClass={onChangeFundClassDropdown}
                    />
                    <PerformanceOptions
                      selectedClass={selectedClass}
                      selectedPerformanceFrequency={
                        selectedPerformanceFrequency
                      }
                      selectedDisplayBenchmark={selectedDisplayBenchmark}
                      selectedDisplayMorningstar={selectedDisplayMorningstar}
                      onChangePerformanceType={onChangePerformanceTypeDropdown}
                      onChangePerformanceFrequency={
                        onChangePerformanceFrequencyDropdown
                      }
                      onChangeDisplayBenchmark={
                        onChangeDisplayBenchmarkCheckbox
                      }
                      onChangeDisplayMorningstar={
                        onChangeDisplayMorningstarCheckbox
                      }
                    />
                  </>
                }
              </>
            )
          },
          headerSummary1: () => {
            return (
              <>
                {selectedPerformanceType === 'nav'
                  ? 'Average Annual Total Returns (%) at NAV'
                  : selectedPerformanceType === 'atmarket'
                  ? 'Average Annual Total Returns (%) at Market'
                  : 'Average Annual Total Returns (%) with Maximum Sales Charge'}{' '}
                as of{' '}
                {selectedPerformanceType === 'nav'
                  ? StringFormatter.formatDateStandard(fundRoot.navAsOfDate)
                  : StringFormatter.formatDateStandard(fundRoot.popAsOfDate)}
              </>
            )
          },
          headerSummary2: () => {
            return (
              <>
                Expense Ratio as of{' '}
                {StringFormatter.formatDateStandard(fundRoot.expenseAsOfDate)}
              </>
            )
          },
          colSpan1: 4,
          colSpan2: 6,
          colSpan3: 3,
          columns: [
            {
              name: 'assetClass',
              className: 'Table-header sorting_disabled',
              ariaLabel: '',
              content: <>&nbsp;</>,
              cell: {
                content: (fund) => (
                  <div className={lookupCategory(fund.categoryName)}></div>
                ),
              },
            },
            {
              name: 'goals',
              className: 'Table-header sorting_disabled',
              ariaLabel: 'Goal: activate to sort column',
              content: <div className="u-padding2gu"></div>,
              cell: {
                content: (fund) => <>{renderInvestorGoalsIcons(fund)}</>,
              },
            },
            {
              name: 'fundName',
              className:
                'Table-header sorting' +
                (selectedSort === 'fundName' || selectedSort === 'symbol'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Fund Name: activate to sort column descending',
              content: <>Fund Name</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'fundName' || selectedSort === 'symbol'
                    ? ' Icon--before'
                    : ''),
                sort: ignoreClass ? 'symbol' : 'fundName',
                sortType: 'string',
              },
              cell: {
                content: (fund) => (
                  <>
                    <a
                      className="u-textBold u-flex u-flexAlignItemsBaseline"
                      href={DOMPurify.sanitize(
                        getRelativeBasePath() +
                          `/investment-products/${
                            ignoreClass
                              ? 'exchange-traded-funds'
                              : 'mutual-funds'
                          }/${StringFormatter.urlSafe(
                            fund.fundName
                          )}/Class-${getFundClass(fund)}/details/?cusip=${
                            fund.cusip
                          }`
                      )}
                    >
                      {ignoreClass ? (
                        <>
                          <span className="u-marginTop2gu u-textSizeMsrp1">
                            {fund.symbol}
                          </span>
                          <span className="u-marginLeft2gu u-textNormal u-textSecondary">
                            {fund.fundName}{' '}
                            {fund.disclosureRef && (
                              <sup>{fund.disclosureRef}</sup>
                            )}
                          </span>
                        </>
                      ) : (
                        fund.fundName
                      )}
                    </a>
                    {!ignoreClass && (
                      <div>
                        {fund.symbol} | {getFundClass(fund)}
                      </div>
                    )}
                    {fund.categoryName === 'Money Market' && (
                      <>
                        <br />
                        <br />
                        <div className="u-textSizeMsrm1">
                          <div className="u-textNoWrap">
                            7-day Current Yield as of{' '}
                            {StringFormatter.formatDateStandard(
                              fund.sevenDayYldDate
                            )}
                            : {fund.sevenDayYldCurrent}
                          </div>
                          <div className="u-textNoWrap">
                            7-day Unsubsidized Yield as of{' '}
                            {StringFormatter.formatDateStandard(
                              fund.sevenDayYldUnsubDate
                            )}
                            : {fund.sevenDayYldUnsub}
                          </div>
                          <div className="u-textNoWrap">
                            7-day Effective Yield as of{' '}
                            {StringFormatter.formatDateStandard(
                              fund.sevenDayYldEffDate
                            )}
                            : {fund.sevenDayYldEff}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ),
              },
            },
            {
              name: 'ytd',
              className:
                'Table-header u-textRight sorting bordered' +
                (selectedSort === 'ytdPercent' ||
                selectedSort === 'ytdPercentPOP'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel:
                'YTD % as of ' +
                StringFormatter.formatDateStandard(fundRoot.ytdAsOfDate) +
                ': activate to sort column',
              content: (
                <>
                  YTD % as of
                  <br />
                  <span className="u-textNoWrap ytd-date">
                    {StringFormatter.formatDateStandard(fundRoot.ytdAsOfDate)}
                  </span>
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'ytdPercent' ||
                  selectedSort === 'ytdPercentPOP'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'nav'
                    ? 'ytdPercent'
                    : 'ytdPercentPOP',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'nav'
                    ? fund.ytdPercent
                    : fund.ytdPercentPOP,
              },
            },
            {
              name: '1year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'navOneYear' || selectedSort === 'popOneYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '1 Year: activate to sort column',
              content: <>1 Year</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'navOneYear' ||
                  selectedSort === 'popOneYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'nav'
                    ? 'navOneYear'
                    : 'popOneYear',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'nav'
                    ? fund.navOneYear
                    : fund.popOneYear,
              },
            },
            {
              name: '3year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'navThreeYear' ||
                selectedSort === 'popThreeYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '3 Year: activate to sort column',
              content: <>3 Year</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'navThreeYear' ||
                  selectedSort === 'popThreeYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'nav'
                    ? 'navThreeYear'
                    : 'popThreeYear',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'nav'
                    ? fund.navThreeYear
                    : fund.popThreeYear,
              },
            },
            {
              name: '5year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'navFiveYear' ||
                selectedSort === 'popFiveYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '5 Year: activate to sort column',
              content: <>5 Year</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'navFiveYear' ||
                  selectedSort === 'popFiveYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'nav'
                    ? 'navFiveYear'
                    : 'popFiveYear',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'nav'
                    ? fund.navFiveYear
                    : fund.popFiveYear,
              },
            },
            {
              name: '10year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'navTenYear' || selectedSort === 'popTenYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '10 Year: activate to sort column',
              content: <>10 Year</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'navTenYear' ||
                  selectedSort === 'popTenYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'nav'
                    ? 'navTenYear'
                    : 'popTenYear',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'nav'
                    ? fund.navTenYear
                    : fund.popTenYear,
              },
            },
            {
              name: 'inception',
              className:
                'Table-header u-textNoWrap u-textRight sorting' +
                (selectedSort === 'navSinceInception' ||
                selectedSort === 'popSinceInception'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Since Fund Inception*: activate to sort column',
              content: (
                <>
                  Since Fund
                  <br />
                  Incept. {!ignoreClass && <>*</>}
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'navSinceInception' ||
                  selectedSort === 'popSinceInception'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'nav'
                    ? 'navSinceInception'
                    : 'popSinceInception',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'nav'
                    ? fund.navSinceInception
                    : fund.popSinceInception,
              },
            },
            {
              name: 'inceptionDt',
              className:
                'Table-header u-textNoWrap u-textRight sorting bordered' +
                (selectedSort === 'inceptionDt'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Fund Inception Date: activate to sort column',
              content: (
                <>
                  Fund Incept.
                  <br />
                  Date
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'inceptionDt' ? ' Icon--before' : ''),
                sort: 'inceptionDt',
                sortType: 'date',
              },
              cell: {
                className: ' u-textNoWrap bordered u-textRight',
                content: (fund) =>
                  StringFormatter.formatDateStandard(fund.inceptionDt),
              },
            },
            {
              name: 'gross',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'grossExp'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Net: activate to sort column',
              content: <>Gross</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'grossExp' ? ' Icon--before' : ''),
                sort: 'grossExp',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) => fund.grossExp,
              },
            },
            {
              name: 'net',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'netExp'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Gross: activate to sort column',
              content: <>Net</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'netExp' ? ' Icon--before' : ''),
                sort: 'netExp',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) => fund.netExp,
              },
            },
            {
              name: 'waiverDt',
              className:
                'Table-header u-textRight sorting bordered' +
                (selectedSort === 'waiverDt'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Fund Waiver Expiration Date: activate to sort column',
              content: (
                <>
                  Waiver Expiration
                  <br />
                  Date
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'waiverDt' ? ' Icon--before' : ''),
                sort: 'waiverDt',
                sortType: 'date',
              },
              cell: {
                className: ' u-textNoWrap bordered u-textRight',
                content: (fund) =>
                  StringFormatter.formatDateStandard(
                    fund.expenseRatioWaiverDate
                  ),
              },
            },
          ],
        },
      },
      {
        name: '#prices-yields',
        info: {
          tag: 'PricesAndYields',
          selector: [
            {
              name: 'priceFunds',
              isArray: false,
            },
          ],
          renderOptions: () => {
            return (
              <>
                {
                  <ClassOptions
                    defaultClassName={DEFAULT_CLASS}
                    selectedClass={selectedClass}
                    classes={classes}
                    onChangeFundClass={onChangeFundClassDropdown}
                  />
                }
              </>
            )
          },
          headerSummary1: () => {
            return (
              <>
                Prices as of{' '}
                {StringFormatter.formatDateStandard(fundRoot.priceAsOfDate)}
              </>
            )
          },
          headerSummary2: () => {
            return (
              <>
                30-day SEC Yield as of{' '}
                {StringFormatter.formatDateStandard(fundRoot.secYldDate)}
              </>
            )
          },
          colSpan1: 3,
          colSpan2: 4,
          colSpan3: 2,
          columns: [
            {
              name: 'assetClass',
              className: 'Table-header sorting_disabled',
              ariaLabel: '',
              content: <>&nbsp;</>,
              cell: {
                content: (fund) => (
                  <div className={lookupCategory(fund.categoryName)}></div>
                ),
              },
            },
            {
              name: 'goals',
              className: 'Table-header sorting_disabled',
              ariaLabel: 'Goal: activate to sort column',
              content: <div className="u-padding2gu"></div>,
              cell: {
                content: (fund) => <>{renderInvestorGoalsIcons(fund)}</>,
              },
            },
            {
              name: 'fundName',
              className:
                'Table-header sorting bordered' +
                (selectedSort === 'fundName' || selectedSort === 'symbol'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Fund Name: activate to sort column descending',
              content: <>Fund Name</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'fundName' || selectedSort === 'symbol'
                    ? ' Icon--before'
                    : ''),
                sort: ignoreClass ? 'symbol' : 'fundName',
                sortType: 'string',
              },
              cell: {
                content: (fund) => (
                  <>
                    <a
                      className="u-textBold u-flex u-flexAlignItemsBaseline"
                      href={DOMPurify.sanitize(
                        getRelativeBasePath() +
                          `/investment-products/${
                            ignoreClass
                              ? 'exchange-traded-funds'
                              : 'mutual-funds'
                          }/${StringFormatter.urlSafe(
                            fund.fundName
                          )}/Class-${getFundClass(fund)}/details/?cusip=${
                            fund.cusip
                          }`
                      )}
                    >
                      {ignoreClass ? (
                        <>
                          <span className="u-marginTop2gu u-textSizeMsrp2">
                            {fund.symbol}
                          </span>
                          <span className="u-marginLeft2gu u-textNoWrap u-textNormal u-textSizeMsrp1 u-textSecondary">
                            {fund.fundName}
                          </span>
                        </>
                      ) : (
                        fund.fundName
                      )}
                    </a>
                    {!ignoreClass && (
                      <div>
                        {fund.symbol} | {getFundClass(fund)}
                      </div>
                    )}
                  </>
                ),
              },
            },
            {
              name: 'navDollar',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'navDollar'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Nav Amount: activate to sort column',
              content: <>Nav $</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'navDollar' ? ' Icon--before' : ''),
                sort: 'navDollar',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) => fund.navDollar,
              },
            },
            {
              name: 'popDollar',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'popDollar'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'POP Amount: activate to sort column',
              content: <>POP $</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'popDollar' ? ' Icon--before' : ''),
                sort: 'popDollar',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) => fund.popDollar,
              },
            },
            {
              name: 'navDollarChange',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'navDollarChange'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Nav Change Amount: activate to sort column',
              content: <>NAV chg ($)</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'navDollarChange' ? ' Icon--before' : ''),
                sort: 'navDollarChange',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) => fund.navDollarChange,
              },
            },
            {
              name: 'navPercentageChange',
              className:
                'Table-header u-textRight sorting bordered' +
                (selectedSort === 'navPercentageChange'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'NAV Change Percentage: activate to sort column',
              content: <>NAV chg (%)</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'navPercentageChange'
                    ? ' Icon--before'
                    : ''),
                sort: 'navPercentageChange',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) => fund.navPercentageChange,
              },
            },
            {
              name: 'secYield',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'secYield'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'SEC Yield Percentage: activate to sort column',
              content: <>SEC Yield (%)</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'secYield' ? ' Icon--before' : ''),
                sort: 'secYield',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) => fund.secYield,
              },
            },
            {
              name: 'secYldUnsubsidized',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'secYldUnsubsidized'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel:
                'SEC Yield Unsubsidized Percentage: activate to sort column',
              content: (
                <>
                  Unsubsidized
                  <br />
                  SEC Yield (%)
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'secYldUnsubsidized'
                    ? ' Icon--before'
                    : ''),
                sort: 'secYldUnsubsidized',
                sortType: 'number',
              },
              cell: {
                className: ' u-textRight',
                content: (fund) => fund.secYldUnsubsidized,
              },
            },
          ],
        },
      },
      {
        name: '#morningstar-ratings',
        info: {
          tag: '1,2,3,4,5',
          selector: [
            {
              name: 'morningStarFunds',
              isArray: false,
            },
          ],
          renderOptions: () => {
            return (
              <>
                {
                  <ClassOptions
                    defaultClassName={DEFAULT_CLASS}
                    selectedClass={selectedClass}
                    classes={classes}
                    onChangeFundClass={onChangeFundClassDropdown}
                  />
                }
                {
                  <MorningstarOptions
                    selectedDisplayMorningstarGroup={
                      selectedDisplayMorningstarGroup
                    }
                    onChangeDisplayMorningstarGroup={
                      onChangeDisplayMorningstarGroupCheckbox
                    }
                  />
                }
              </>
            )
          },
          headerSummary1: () => {
            return (
              <>
                Morningstar Rating as of{' '}
                {(funds.length > 0 &&
                  StringFormatter.formatDateStandard(funds[0].asOfDate)) ||
                  ''}
                <p className="u-paddingTop2gu u-textSecondary u-textNormal u-textSizeMsrm1">
                  (based on a Morningstar Risk-Adjusted Return measure)
                </p>
              </>
            )
          },
          headerSummary2: () => null,
          colSpan1: 3,
          colSpan2: 4,
          colSpan3: 1,
          columns: [
            {
              name: 'assetClass',
              className: 'Table-header sorting_disabled',
              ariaLabel: '',
              content: <>&nbsp;</>,
              cell: {
                content: (fund) => (
                  <div className={lookupCategory(fund.categoryName)}></div>
                ),
              },
            },
            {
              name: 'goals',
              className: 'Table-header sorting_disabled',
              ariaLabel: 'Goal: activate to sort column',
              content: <div className="u-padding2gu"></div>,
              cell: {
                content: (fund) => <>{renderInvestorGoalsIcons(fund)}</>,
              },
            },
            {
              name: 'fundName',
              className:
                'Table-header sorting bordered' +
                (selectedSort === 'fundName' || selectedSort === 'symbol'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Fund Name: activate to sort column descending',
              content: <>Fund Name</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'fundName' || selectedSort === 'symbol'
                    ? ' Icon--before'
                    : ''),
                sort: ignoreClass ? 'symbol' : 'fundName',
                sortType: 'string',
              },
              cell: {
                content: (fund) => (
                  <>
                    <a
                      className="u-textBold u-flex u-flexAlignItemsBaseline"
                      href={DOMPurify.sanitize(
                        getRelativeBasePath() +
                          `/investment-products/${
                            ignoreClass
                              ? 'exchange-traded-funds'
                              : 'mutual-funds'
                          }/${StringFormatter.urlSafe(
                            fund.fundName
                          )}/Class-${getFundClass(fund)}/details/?cusip=${
                            fund.cusip
                          }`
                      )}
                    >
                      {ignoreClass ? (
                        <>
                          <span className="u-marginTop2gu u-textSizeMsrp2">
                            {fund.symbol}
                          </span>
                          <span className="u-marginLeft2gu u-textNoWrap u-textNormal u-textSizeMsrp1 u-textSecondary">
                            {fund.fundName}
                          </span>
                        </>
                      ) : (
                        fund.fundName
                      )}
                    </a>
                    {!ignoreClass && (
                      <div>
                        {fund.symbol} | {getFundClass(fund)}
                      </div>
                    )}
                  </>
                ),
              },
            },
            {
              name: 'msOverallRating',
              className:
                'Table-header sorting' +
                (selectedSort === 'msOverallRating'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Morningstar Overall Rating: activate to sort column',
              content: <>Overall</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'msOverallRating' ? ' Icon--before' : ''),
                sort: 'msOverallRating',
                sortType: 'number',
                sortDirection: false,
              },
              cell: {
                content: (fund) =>
                  renderStars(fund.msOverallRating, fund.overallFunds),
              },
            },
            {
              name: 'threeYearRating',
              className:
                'Table-header sorting' +
                (selectedSort === 'threeYearRating'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Morningstar 3 Year Rating: activate to sort column',
              content: <>3 Year</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'threeYearRating' ? ' Icon--before' : ''),
                sort: 'threeYearRating',
                sortType: 'number',
                sortDirection: false,
              },
              cell: {
                content: (fund) =>
                  renderStars(fund.threeYearRating, fund.threeYearFunds),
              },
            },
            {
              name: 'fiveYearRating',
              className:
                'Table-header sorting' +
                (selectedSort === 'fiveYearRating'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Morningstar 5 Year Rating: activate to sort column',
              content: <>5 Year</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'fiveYearRating' ? ' Icon--before' : ''),
                sort: 'fiveYearRating',
                sortType: 'number',
                sortDirection: false,
              },
              cell: {
                content: (fund) =>
                  renderStars(fund.fiveYearRating, fund.fiveYearFunds),
              },
            },
            {
              name: 'tenYearRating',
              className:
                'Table-header sorting bordered' +
                (selectedSort === 'tenYearRating'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Morningstar 10 Year Rating: activate to sort column',
              content: <>10 Year</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'tenYearRating' ? ' Icon--before' : ''),
                sort: 'tenYearRating',
                sortType: 'number',
                sortDirection: false,
              },
              cell: {
                className: '',
                content: (fund) =>
                  renderStars(fund.tenYearRating, fund.tenYearFunds),
              },
            },
            {
              name: 'msCategoryName',
              className:
                'Table-header sorting' +
                (selectedSort === 'msCategoryName'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Morningstar Category: activate to sort column',
              content: <>Morningstar Category</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'msCategoryName' ? ' Icon--before' : ''),
                sort: 'msCategoryName',
                sortType: 'array',
              },
              cell: {
                content: (fund) => fund.msCategoryName,
              },
              hide: selectedDisplayMorningstarGroup,
            },
          ],
        },
      },
      {
        name: '#capital-gains',
        info: {
          tag: 'capGains',
          selector: [
            {
              name: 'capitalGains',
              isArray: false,
            },
          ],
          renderOptions: () => {
            return (
              <>
                {
                  <ClassOptions
                    defaultClassName={DEFAULT_CLASS}
                    selectedClass={selectedClass}
                    classes={classes}
                    onChangeFundClass={onChangeFundClassDropdown}
                  />
                }
              </>
            )
          },
          headerSummary1: () => {
            return <>Breakdown of Capital Gains Distributions and Estimates </>
          },
          headerSummary2: () => null,
          parseData: sortCapitalGains,
          colSpan1: 5,
          colSpan2: 4,
          colSpan3: null,
          columns: [
            {
              name: 'assetClass',
              className: 'Table-header sorting_disabled',
              ariaLabel: '',
              content: <>&nbsp;</>,
              cell: {
                className: ' u-alignTop',
                content: (fund) => (
                  <div className={lookupCategory(fund.categoryName)}></div>
                ),
              },
            },
            {
              name: 'goals',
              className: 'Table-header sorting_disabled',
              ariaLabel: 'Goal: activate to sort column',
              content: <div className="u-padding2gu"></div>,
              cell: {
                className: ' u-alignTop',
                content: (fund) => (
                  <div
                    className={
                      ignoreClass
                        ? ''
                        : 'titleWrapper u-flex u-flexCol u-flexJustifyCenter'
                    }
                  >
                    {renderInvestorGoalsIcons(fund)}
                  </div>
                ),
              },
            },
            {
              name: 'fundName',
              className:
                'Table-header sorting' +
                (selectedSort === 'fundName' || selectedSort === 'symbol'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Fund Name: activate to sort column descending',
              content: <>Fund Name</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'fundName' || selectedSort === 'symbol'
                    ? ' Icon--before'
                    : ''),
                sort: ignoreClass ? 'symbol' : 'fundName',
                sortType: 'string',
              },
              cell: {
                className: ignoreClass ? '' : ' u-alignTop',
                content: (fund) => (
                  <div
                    className={
                      ignoreClass
                        ? ''
                        : 'titleWrapper u-flex u-flexCol u-flexJustifyCenter'
                    }
                  >
                    <a
                      className="u-textBold u-flex u-flexAlignItemsBaseline"
                      href={DOMPurify.sanitize(
                        getRelativeBasePath() +
                          `/investment-products/mutual-funds/${StringFormatter.urlSafe(
                            fund.fundName
                          )}/Class-${getFundClass(fund)}/details/?cusip=${
                            fund.cusip
                          }`
                      )}
                    >
                      {ignoreClass ? (
                        <>
                          <span className="u-marginTop2gu u-textSizeMsrp2">
                            {fund.symbol}
                          </span>
                          <span className="u-marginLeft2gu u-textNoWrap u-textNormal u-textSizeMsrp1 u-textSecondary">
                            {fund.fundName}
                          </span>
                        </>
                      ) : (
                        fund.fundName
                      )}
                    </a>
                    {!ignoreClass && (
                      <div>
                        {fund.symbol} | {getFundClass(fund)}
                      </div>
                    )}
                  </div>
                ),
              },
            },
            {
              name: 'recordDate',
              className:
                'Table-header sorting u-paddingLeft0' +
                (selectedSort === 'recordDate'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Record Date: activate to sort column',
              content: <>Record Date</>,
              button: {
                className:
                  'Table-headerNode u-paddingRight3gu u-paddingLeft0' +
                  (selectedSort === 'recordDate' ? ' Icon--before' : ''),
                sort: 'recordDate',
                sortType: 'date',
              },
              cell: {
                className: ' u-padding0',
                content: (fund) => {
                  const hasFundDistributions = hasFundDistributionsEstimates(
                    fund,
                    'distributions'
                  )
                  const hasFundEstimates = hasFundDistributionsEstimates(
                    fund,
                    'estimates'
                  )

                  return (
                    <div className="u-flex u-flexCol">
                      {hasFundDistributions && (
                        <div className="u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu">
                          <div>
                            <em>Distributions</em>
                          </div>
                          {fund.distributions &&
                            fund.distributions.map((value, index) => {
                              return (
                                <div className="u-paddingTop2gu" key={index}>
                                  {StringFormatter.formatDateStandard(
                                    value.recordDate
                                  )}
                                </div>
                              )
                            })}
                        </div>
                      )}
                      {hasFundEstimates && (
                        <div
                          className={`u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu ${
                            hasFundDistributions
                              ? 'u-borderColorNeutralLight u-borderTop'
                              : ''
                          }`}
                        >
                          <div>
                            <em>Estimates</em>
                          </div>
                          <div className="u-paddingTop2gu u-textNoWrap">
                            {StringFormatter.formatDateStandard(
                              fund?.estimates?.recordDate
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                },
              },
            },
            {
              name: 'payableDate',
              className:
                'Table-header sorting bordered u-textRight' +
                (selectedSort === 'exDivdndDate'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Ex/Payable Date: activate to sort column',
              content: <>Ex/Payable Date</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-paddingRight3gu' +
                  (selectedSort === 'exDivdndDate' ? ' Icon--before' : ''),
                sort: 'exDivdndDate',
                sortType: 'date',
              },
              cell: {
                className:
                  ' u-paddingVert0 u-paddingLeft0 u-textNoWrap bordered u-textRight',
                content: (fund) => {
                  const hasFundDistributions = hasFundDistributionsEstimates(
                    fund,
                    'distributions'
                  )
                  const hasFundEstimates = hasFundDistributionsEstimates(
                    fund,
                    'estimates'
                  )

                  return (
                    <div className="u-flex u-flexCol">
                      {hasFundDistributions && (
                        <div className="u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu">
                          <div>&nbsp;</div>
                          {fund.distributions &&
                            fund.distributions.map((value, index) => {
                              return (
                                <div className="u-paddingTop2gu" key={index}>
                                  {StringFormatter.formatDateStandard(
                                    value.exDivdndDate
                                  )}
                                </div>
                              )
                            })}
                        </div>
                      )}
                      {hasFundEstimates && (
                        <div
                          className={`u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu ${
                            hasFundDistributions
                              ? 'u-borderColorNeutralLight u-borderTop'
                              : ''
                          }`}
                        >
                          <div>&nbsp;</div>
                          <div className="u-paddingTop2gu">
                            {StringFormatter.formatDateStandard(
                              fund?.estimates?.exDivdndDate
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                },
              },
            },
            {
              name: 'shortTermCapGain',
              className:
                'Table-header u-textLeft sorting' +
                (selectedSort === 'shortTermCapGain'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Short-Term Capital Gains: activate to sort column',
              content: (
                <>
                  Short-Term
                  <br />
                  Capital Gains ($)
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu u-textLeft' +
                  (selectedSort === 'shortTermCapGain' ? ' Icon--before' : ''),
                sort: 'shortTermCapGain',
                sortType: 'number',
              },
              cell: {
                className: ' u-paddingVert0 u-paddingRight0',
                content: (fund) => {
                  const hasFundDistributions = hasFundDistributionsEstimates(
                    fund,
                    'distributions'
                  )
                  const hasFundEstimates = hasFundDistributionsEstimates(
                    fund,
                    'estimates'
                  )

                  return (
                    <div className="u-flex u-flexCol">
                      {hasFundDistributions && (
                        <div className="u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu">
                          <div>
                            <em>Distributions</em>
                          </div>
                          {fund.distributions &&
                            fund.distributions.map((value, index) => {
                              return (
                                <div className="u-paddingTop2gu" key={index}>
                                  {formatToFixed(value.shortTermCapGain, 5)}
                                </div>
                              )
                            })}
                        </div>
                      )}
                      {hasFundEstimates && (
                        <div
                          className={`u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu ${
                            hasFundDistributions
                              ? 'u-borderColorNeutralLight u-borderTop'
                              : ''
                          }`}
                        >
                          <div>
                            <em>Estimates</em>
                          </div>
                          <div className="u-paddingTop2gu u-textNoWrap">
                            {formatToFixed(fund?.estimates?.shortTermCapGainSt)}{' '}
                            &minus;{' '}
                            {formatToFixed(
                              fund?.estimates?.shortTermCapGainEnd
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                },
              },
            },
            {
              name: 'longTermCapGain',
              className:
                'Table-header u-textLeft sorting' +
                (selectedSort === 'longTermCapGain'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Long-Term Capital Gains: activate to sort column',
              content: (
                <>
                  Long-Term Capital
                  <br />
                  Gains ($)
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu u-textLeft' +
                  (selectedSort === 'longTermCapGain' ? ' Icon--before' : ''),
                sort: 'longTermCapGain',
                sortType: 'number',
              },
              cell: {
                className: ' u-padding0',
                content: (fund) => {
                  const hasFundDistributions = hasFundDistributionsEstimates(
                    fund,
                    'distributions'
                  )
                  const hasFundEstimates = hasFundDistributionsEstimates(
                    fund,
                    'estimates'
                  )

                  return (
                    <div className="u-flex u-flexCol">
                      {hasFundDistributions && (
                        <div className="u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu">
                          <div>&nbsp;</div>

                          {fund.distributions &&
                            fund.distributions.map((value, index) => {
                              return (
                                <div className="u-paddingTop2gu" key={index}>
                                  {formatToFixed(value.longTermCapGain, 5)}
                                </div>
                              )
                            })}
                        </div>
                      )}
                      {hasFundEstimates && (
                        <div
                          className={`u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu ${
                            hasFundDistributions
                              ? 'u-borderColorNeutralLight u-borderTop'
                              : ''
                          }`}
                        >
                          <div>&nbsp;</div>
                          <div className="u-paddingTop2gu u-textNoWrap">
                            {formatToFixed(fund?.estimates?.longTermCapGainSt)}{' '}
                            &minus;{' '}
                            {formatToFixed(fund?.estimates?.longTermCapGainEnd)}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                },
              },
            },
            {
              name: 'totalCapGain',
              className:
                'Table-header u-textLeft sorting' +
                (selectedSort === 'totalCapGain'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Total Capital Gains: activate to sort column',
              content: (
                <>
                  Total Capital
                  <br />
                  Gains ($)
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu u-textLeft' +
                  (selectedSort === 'totalCapGain' ? ' Icon--before' : ''),
                sort: 'totalCapGain',
                sortType: 'number',
              },
              cell: {
                className: ' u-padding0',
                content: (fund) => {
                  const hasFundDistributions = hasFundDistributionsEstimates(
                    fund,
                    'distributions'
                  )
                  const hasFundEstimates = hasFundDistributionsEstimates(
                    fund,
                    'estimates'
                  )

                  return (
                    <div className="u-flex u-flexCol">
                      {hasFundDistributions && (
                        <div className="u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu">
                          <div>&nbsp;</div>

                          {fund.distributions &&
                            fund.distributions.map((value, index) => {
                              return (
                                <div className="u-paddingTop2gu" key={index}>
                                  {formatToFixed(value.totalCapGain, 5)}
                                </div>
                              )
                            })}
                        </div>
                      )}
                      {hasFundEstimates && (
                        <div
                          className={`u-flex u-flexCol u-paddingVert2gu u-paddingRight2gu ${
                            hasFundDistributions
                              ? 'u-borderColorNeutralLight u-borderTop'
                              : ''
                          }`}
                        >
                          <div>&nbsp;</div>
                          <div className="u-paddingTop2gu u-textNoWrap">
                            {formatToFixed(fund?.estimates?.totalCapGainSt)}{' '}
                            &minus;{' '}
                            {formatToFixed(fund?.estimates?.totalCapGainEnd)}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                },
              },
            },
            {
              name: 'totalCapGainPct',
              className:
                'Table-header u-textLeft sorting' +
                (selectedSort === 'totalCapGainPct'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Percent of Record Date NAV: activate to sort column',
              content: (
                <>
                  % of Record
                  <br />
                  Date NAV
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu u-textLeft' +
                  (selectedSort === 'totalCapGainPct' ? ' Icon--before' : ''),
                sort: 'totalCapGainPct',
                sortType: 'number',
              },
              cell: {
                className: ' u-padding0',
                content: (fund) => {
                  const hasFundDistributions = hasFundDistributionsEstimates(
                    fund,
                    'distributions'
                  )
                  const hasFundEstimates = hasFundDistributionsEstimates(
                    fund,
                    'estimates'
                  )

                  return (
                    <div className="u-flex u-flexCol">
                      {hasFundDistributions && (
                        <div className="u-flex u-flexCol u-padding2gu">
                          <div>&nbsp;</div>

                          {fund.distributions &&
                            fund.distributions.map((value, index) => {
                              return (
                                <div className="u-paddingTop2gu" key={index}>
                                  {formatToFixed(value.totalCapGainPct)}
                                </div>
                              )
                            })}
                        </div>
                      )}
                      {hasFundEstimates && (
                        <div
                          className={`u-flex u-flexCol u-padding2gu ${
                            hasFundDistributions
                              ? 'u-borderColorNeutralLight u-borderTop'
                              : ''
                          }`}
                        >
                          <div>&nbsp;</div>
                          <div className="u-paddingTop2gu u-textNoWrap">
                            {formatToFixed(fund?.estimates?.totalCapGainPctSt)}{' '}
                            &minus;{' '}
                            {formatToFixed(fund?.estimates?.totalCapGainPctEnd)}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                },
              },
            },
          ],
        },
      },
    ]

    const _aspect = _aspects.find(
      (a) => a.name === (section || selectedSection)
    ).info

    // Apply the `aspects` prop
    if (aspects) {
      const _aspectModifier = aspects.find(
        (a) => a.name === (section || selectedSection)
      ).info

      _aspect.colSpan1 = _aspectModifier.colSpan1 || _aspect.colSpan1
      _aspect.colSpan2 = _aspectModifier.colSpan2 || _aspect.colSpan2
      _aspect.colSpan3 = _aspectModifier.colSpan3 || _aspect.colSpan3

      _aspectModifier.columns.forEach((_column, i) => {
        _aspect.columns[i] = { ..._aspect.columns[i], ..._column }
      })
    }

    return _aspect
  }

  useEffect(() => {
    const paramExpandable = urlSearchParams.get('expandable')

    if (paramExpandable) {
      setIsExpandable(true)

      // if (paramExpandable === '2') {
      //   setIsFilterOnForced(true)
      // }
    }
  }, [])

  useEffect(() => {
    if (!classes) {
      initializeFundClasses()
    }

    return () => {}
  }, [])

  useEffect(() => {
    if (isInitialLoad) {
      initializeFunds()
      setIsInitialLoad(false)
    }

    return () => {}
  }, [selectedSection, selectedClass, selectedPerformanceFrequency])

  useEffect(() => {
    initializeFundsFiltered()

    if (funds && funds.length > 0) {
      window.prerenderReady = true
    }

    return () => {}
  }, [funds, selectedFundSearch, selectedFilter])

  useEffect(() => {
    if (isExpanded) {
      document
        .querySelectorAll('.Expandable')
        .forEach((c) => c.classList.add('u-hidden'))

      // document.querySelectorAll('.TwoColumnLayout-leftContainer').forEach(c => { c.classList.remove('u-md-size9of12'); c.classList.remove('u-lg-size9of12') })

      // if (isAutoScroll) {
      //   window.scrollTo({
      //     top: 300, // TODO
      //     behavior: 'smooth'
      //   })
      // }
    } else {
      document
        .querySelectorAll('.Expandable')
        .forEach((c) => c.classList.remove('u-hidden'))

      // document.querySelectorAll('.TwoColumnLayout-leftContainer').forEach(c => { c.classList.add('u-md-size9of12'); c.classList.add('u-lg-size9of12') })

      // if (isAutoScroll) {
      //   window.scrollTo({
      //     top: 1000, // TODO
      //     behavior: 'smooth'
      //   })
      // }
    }
  }, [isExpanded])

  const useMorningstarGroup = () => {
    return (
      selectedSection === '#morningstar-ratings' &&
      selectedDisplayMorningstarGroup
    )
  }

  const useManagementStyle = () => {
    return (
      (selectedSection === '#performance' ||
        selectedSection === '#prices-yields') &&
      isETF
      // selectedDisplayManagementStyle
    )
  }

  const useMorningstarAverage = () => {
    return selectedSection === '#performance' && selectedDisplayMorningstar
  }

  const useBenchmark = () => {
    return selectedSection === '#performance' && selectedDisplayBenchmark
  }

  const sortFunds = (fundsArray) => {
    fundsArray.sort((fund1, fund2) => {
      const a = selectedSortDirection ? fund1 : fund2
      const b = selectedSortDirection ? fund2 : fund1

      // Sort by Morningstar Category first if applicable
      if (useMorningstarGroup()) {
        const categoryCompare = (a['msCategoryName'] || '').localeCompare(
          b['msCategoryName'] || '',
          'en',
          {
            sensitivity: 'base',
          }
        )

        if (categoryCompare) {
          return categoryCompare
        }
      }

      if (useManagementStyle()) {
        const managementCompare = (a['managementStyle'] || '').localeCompare(
          b['managementStyle'] || '',
          'en',
          {
            sensitivity: 'base',
          }
        )

        if (managementCompare) {
          return managementCompare
        }
      }

      // Sort by selected sort
      switch (selectedSortType) {
        case 'number': {
          const aValue =
            typeof a[selectedSort] === 'string'
              ? parseFloat(a[selectedSort] === '-' ? 0.0 : a[selectedSort])
              : a[selectedSort]
          const bValue =
            typeof b[selectedSort] === 'string'
              ? parseFloat(b[selectedSort] === '-' ? 0.0 : b[selectedSort])
              : b[selectedSort]

          const numberCompare = aValue < bValue ? -1 : aValue > bValue ? 1 : 0

          // Sort by Fund Name second if necessary (always ascending)
          if (numberCompare) {
            return numberCompare
          } else {
            return (fund1['fundName'] || '').localeCompare(
              fund2['fundName'] || '',
              'en',
              { sensitivity: 'base' }
            )
          }
        }
        case 'array':
          return (a[selectedSort][0] || '').localeCompare(
            b[selectedSort][0] || '',
            'en',
            { sensitivity: 'base' }
          )
        default:
          return (a[selectedSort] || '').localeCompare(
            b[selectedSort] || '',
            'en',
            { sensitivity: 'base' }
          )
      }
    })

    return fundsArray
  }

  const downloadFunds = (type) => {
    const _url = getDownload({
      type,
      selectedClass,
      selectedFilter,
      selectedDisplayBenchmark,
      selectedDisplayMorningstar,
    })

    window.location = encodeForURL(_url)
  }

  const initializeFundsFiltered = (fundsArray) => {
    const _funds = fundsArray || funds

    const selectedCategoriesLength =
      (selectedFilter.categories && selectedFilter.categories.length) || 0
    const selectedGoalsLength =
      (selectedFilter.goals && selectedFilter.goals.length) || 0
    const selectedTypesLength =
      (selectedFilter.types && selectedFilter.types.length) || 0
    const selectedManagementStylesLength =
      (selectedFilter.managementStyles &&
        selectedFilter.managementStyles.length) ||
      0

    const selectedTypes = selectedTypesLength > 0 && selectedFilter.types
    const selectedCategories =
      selectedCategoriesLength > 0 && selectedFilter.categories
    const selectedGoals = selectedGoalsLength > 0 && selectedFilter.goals
    const selectedManagementStyles =
      selectedManagementStylesLength > 0 && selectedFilter.managementStyles

    if (
      selectedFundSearch ||
      selectedCategories ||
      selectedGoals ||
      selectedTypes ||
      selectedManagementStyles
    ) {
      const _fundsFiltered = _funds.filter((fund) => {
        // Search
        const fundSearchTest =
          !selectedFundSearch ||
          fund.fundName
            .toLowerCase()
            .indexOf(selectedFundSearch.toLowerCase()) > -1 ||
          fund.symbol.toLowerCase().indexOf(selectedFundSearch.toLowerCase()) >
            -1

        // Type
        const filterFeature =
          selectedTypes &&
          selectedTypes.indexOf('featureFund') > -1 &&
          fund &&
          fund.filters &&
          fund.filters.find((filter) => filter.filter === 'featureFund')
        const filterMulti =
          selectedTypes &&
          selectedTypes.indexOf('multiManager') > -1 &&
          fund &&
          fund.filters &&
          fund.filters.find((filter) => filter.filter === 'multiManager')
        const morningstarRating =
          selectedTypes &&
          selectedTypes.indexOf('manyStars') > -1 &&
          fund &&
          fund.msOverallRating > 3

        const typeTest =
          !selectedTypes || filterFeature || filterMulti || morningstarRating

        // Category
        const filterCategory =
          fund &&
          fund.filters &&
          fund.filters.find((filter) => filter.filter === 'InvestmentCategory')

        const categoryTest =
          !selectedCategories ||
          selectedCategories.indexOf(fund?.styleId?.toString()) > -1 ||
          (filterCategory &&
            selectedCategories.indexOf(filterCategory.filterValue[0].desc) > -1)

        // Goal
        const filterGoal =
          fund &&
          fund.filters &&
          fund.filters.find(
            (filter) =>
              filter.filter === 'investorGoal' ||
              filter.filter === 'InvestmentStrategy'
          )

        const goalTest =
          !selectedGoals ||
          (filterGoal &&
            selectedGoals.reduce(
              (found, goal) =>
                found ||
                !!filterGoal.filterValue.find(
                  (filterValue) =>
                    filterValue.code === goal || filterValue.desc === goal
                ),
              false
            ))

        // Management Style
        const managementStyleTest =
          !selectedManagementStyles ||
          selectedManagementStyles.indexOf(fund.managementStyle) > -1

        // Does fund meet all tests?
        return (
          fundSearchTest &&
          typeTest &&
          categoryTest &&
          goalTest &&
          managementStyleTest
        )
      })

      setIsFilterOn(true)

      setSelectedFilterCount(
        selectedCategoriesLength +
          selectedGoalsLength +
          selectedTypesLength +
          selectedManagementStylesLength
      )

      setFundsFiltered(_fundsFiltered)
    } else {
      setIsFilterOn(false)

      setSelectedFilterCount(0)

      setFundsFiltered([])
    }
  }

  const initializeFundClassesSpecialCategory = (fundClass) => {
    // Ensure special 'Alternative' category exists
    const alternativeCategory = fundClass.investmentCategories.find(
      (category) => category.categoryName === 'Alternative'
    )

    if (!alternativeCategory) {
      const allocationCategory = fundClass.investmentCategories.find(
        (category) => category.categoryName === 'Asset Allocation'
      )

      if (allocationCategory) {
        const indexOfAllocationCategory =
          fundClass.investmentCategories.indexOf(allocationCategory)

        fundClass.investmentCategories.splice(
          indexOfAllocationCategory + 1,
          0,
          { categoryName: 'Alternative', count: 0, styleId: '33' }
        )
      }
    }

    return fundClass
  }

  const initializeFundClasses = async () => {
    const data = await getMetadata()
    const _classes = data.value.classTotals
      .map((c) => {
        c.className = c.className.replace('Class ', '')

        return c
      })
      .sort((a, b) => a.className.localeCompare(b.className))

    setClasses(_classes)

    const _params = new URLSearchParams(window.location.search)

    const _paramClass = _params.get('class')

    const _selectedClass =
      _classes.find(
        (fundClass) => fundClass.className === (_paramClass || DEFAULT_CLASS)
      ) || _classes[0]

    initializeFundClassesSpecialCategory(_selectedClass)

    setSelectedClass(_selectedClass)
    setIsInitialLoad(true)
  }

  const initializeFunds = async () => {
    let _useHash = false

    const _hash = location.hash

    // is it a valid hash?
    if (
      _hash &&
      [
        '#performance',
        '#prices-yields',
        '#morningstar-ratings',
        '#capital-gains',
      ].indexOf(_hash) >= 0
    ) {
      _useHash = true

      setSelectedSection(_hash)
      setIsInitialLoad(true)

      onChangeSection && onChangeSection(_hash)
    }

    const aspect = getAspect(_useHash ? _hash : '')

    const data = await getData(
      aspect.tag,
      (selectedClass && selectedClass.className) || DEFAULT_CLASS
    )

    setIsETF(!Object.is(data?.value?.etfs, null))

    if (_hash !== location.hash) {
      return
    }

    const _fundRoot = (data.value && data.value[rootNode]) || {
      capitalGains: [],
    }

    setFundRoot(_fundRoot)

    setIsDataLoading(false)

    const _funds = aspect.selector.reduce(
      (prev, curr) => (curr.isArray ? prev[curr.name][0] : prev[curr.name]),
      _fundRoot
    )

    if (parseData) {
      parseData(_funds)
    }

    const _fundsParsed = aspect.parseData ? aspect.parseData(_funds) : _funds

    setFunds(_fundsParsed)
  }

  const sortCapitalGains = (funds) => {
    funds?.forEach((fund) => {
      fund?.distributions?.sort((a, b) => {
        return a.recordDate.localeCompare(b.recordDate)
      })
    })

    return funds
  }

  const getFundClass = (fund) => {
    return fund.fundClass || selectedClass.className || DEFAULT_CLASS
  }

  const onClickSection = (event) => {
    //only handle click event if the clicked tab is different from current selected tab
    if (selectedSection !== event.currentTarget.hash) {
      setFunds([])

      setSelectedSection(event.currentTarget.hash)
      setIsInitialLoad(true)

      onChangeSection && onChangeSection(event.currentTarget.hash)

      setIsDataLoading(true)
    }
  }

  const onChangeFundSearch = (event) => {
    setFundSearch(event.currentTarget.value)
  }

  const onChangeFundClassDropdown = (event) => {
    const _selectedClass = classes.find(
      (fundClass) =>
        fundClass.className === event.currentTarget.selectedOptions[0].value
    )

    initializeFundClassesSpecialCategory(_selectedClass)

    setFunds([])

    setSelectedClass(_selectedClass)
    setIsInitialLoad(true)

    setIsDataLoading(true)
  }

  const onChangePerformanceTypeDropdown = (event) => {
    setSelectedPerformanceType(event.currentTarget.selectedOptions[0].value)
  }

  const onChangePerformanceFrequencyDropdown = (event) => {
    setFunds([])

    setSelectedPerformanceFrequency(
      event.currentTarget.selectedOptions[0].value
    )
    setIsInitialLoad(true)

    setIsDataLoading(true)
  }

  const onChangeDisplayBenchmarkCheckbox = (event) => {
    setSelectedDisplayBenchmark(event.currentTarget.checked)
  }

  const onChangeDisplayMorningstarCheckbox = (event) => {
    setSelectedDisplayMorningstar(event.currentTarget.checked)
  }

  const onChangeDisplayMorningstarGroupCheckbox = (event) => {
    setSelectedDisplayMorningstarGroup(event.currentTarget.checked)
    setSelectedGroups([])
  }

  const onClickToggleFilter = () => {
    setIsFilterOpen(!isFilterOpen)
  }

  const onChangeFilter = (filter) => {
    setSelectedFilter(filter)
  }

  const onClickSort = (event) => {
    const sort = event.currentTarget.dataset.sort
    const sortType = event.currentTarget.dataset.sortType
    const sortDirection = !!parseInt(event.currentTarget.dataset.sortDirection)

    setSelectedSortType(sortType)

    if (sort === selectedSort) {
      setSelectedSortDirection(!selectedSortDirection)
    } else {
      setSelectedSort(sort)
      setSelectedSortDirection(sortDirection)
    }
  }

  const onClickToggleGroup = (event) => {
    const group = event.currentTarget.dataset.group

    updateArray(selectedGroups, group, selectedGroups.indexOf(group) < 0)

    setSelectedGroups([...selectedGroups])
  }

  const onClickToggleManagementStyleGroup = (event) => {
    const group = event.currentTarget.dataset.group

    updateArray(
      collapsedManagementStyleGroups,
      group,
      collapsedManagementStyleGroups?.indexOf(group) < 0
    )

    setCollapsedManagementStyleGroups([...collapsedManagementStyleGroups])
  }

  const onClickDownloadCSV = (event) => {
    event.preventDefault()

    downloadFunds('csv')
  }

  const onClickDownloadTSV = (event) => {
    event.preventDefault()

    downloadFunds('tsv')
  }

  const onClickDownloadCapGains = (event, type = 'productSummary') => {
    event.preventDefault()

    const capGainsParams = {
      type,
      period: null,
      className: null,
    }

    const _url = getDownloadCapGains(capGainsParams)

    window.location = encodeForURL(_url)
  }

  const onClickViewDisclosures = () => {
    const element = document.getElementById('performanceDisclosure')
    const headerOffset = -100

    if (element) {
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + headerOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  const onClickExpandCollapse = () => {
    setIsExpanded(!isExpanded)
  }

  const renderColumnHeader = (column) => {
    return (
      <th
        key={column.name}
        className={column.className + ' u-bgColorBrand'}
        role="columnheader"
        aria-controls="mutual-funds-table"
        aria-label={column.ariaLabel}
      >
        {column.button ? (
          <button
            className={column.button.className}
            data-sort={column.button.sort}
            data-sort-type={column.button.sortType}
            data-sort-direction={
              typeof column.button.sortDirection !== 'undefined'
                ? column.button.sortDirection
                  ? 1
                  : 0
                : selectedSortDirection
                ? 1
                : 0
            }
            onClick={onClickSort}
          >
            {column.content}
          </button>
        ) : (
          <>{column.content}</>
        )}
      </th>
    )
  }

  const renderColumnCell = (column, fund) => {
    return (
      <>
        <td
          key={column.name + fund.cusip}
          tabIndex="1"
          className={'Table-cell' + (column.cell.className || '')}
        >
          {column.cell.content(fund, column)}
        </td>
      </>
    )
  }

  const renderInvestorGoalsIcons = (fund) => {
    const filter =
      fund &&
      fund.filters &&
      fund.filters.find((filter) => filter.filter === 'investorGoal')

    if (filter && filter.filterValue) {
      return (
        <>
          {filter.filterValue
            .sort((a, b) => a.desc.localeCompare(b.desc))
            .map((filterVal) => {
              return (
                <div
                  key={filterVal.code}
                  className={
                    'icon-32 ' +
                    'icon-' +
                    lookupIcon(filterVal.code) +
                    '-blue-ltblue'
                  }
                  title={filterVal.desc}
                />
              )
            })}
        </>
      )
    }

    return null
  }

  const renderStars = (rating, count) => {
    const getStars = () => {
      return [1, 2, 3, 4, 5].map((stars) => {
        if (rating >= stars) {
          return (
            <span
              key={'star' + stars}
              aria-hidden="true"
              className="Icon u-textSizeMsrp1 u-textColorBrandLight"
            >
              &#x2605;
            </span>
          )
        } else {
          return (
            <span
              key={'star' + stars}
              aria-hidden="true"
              className="Icon u-textSizeMsrp1 u-textColorBrandLight"
            >
              &#x2606;
            </span>
          )
        }
      })
    }

    let _rating = rating

    if (typeof _rating !== 'number') {
      _rating = _rating ? parseInt(_rating) || 0 : 0
    }

    return (
      <div className="u-textNoWrap">
        {typeof _rating !== 'number' ? (
          _rating
        ) : (
          <>
            {getStars(_rating)}
            {!useMorningstarGroup() && (
              <>
                <br />
                <div className="u-textNoWrap">{count || 0} Funds</div>
              </>
            )}
          </>
        )}
      </div>
    )
  }

  const renderEmptyTableData = (count) => {
    let jsx = []

    while (count > 0) {
      jsx.push(<td className="Table-cell">{''}</td>)
      count--
    }

    return jsx
  }

  const aspect = getAspect()

  let currentKey = ''
  let currentMorningstarCategory = ''
  let currentManagementStyleKey = ''
  let currentManagementStyle = ''
  let currentStripe = false

  return (
    <>
      {/* TABS */}
      <div className="u-paddingTop3gu u-borderColorNeutralLight u-borderTop0 u-borderBottom u-borderLeft0 u-borderRight0 u-bgColorWhite">
        <div className="u-sizeConstrained u-flex u-flexJustifyBetween">
          <div></div>
          <ul className="List List--inline List--selectable u-flexJustifyStart">
            <li
              className={
                'u-textSizeMsrp1 u-sm-paddingHoriz1gu u-paddingHoriz5gu u-textBold List-item u-sm-textSizeMsr u-sm-flex u-textCenter u-flexAlignItemsCenter u-sm-flexGrow1 u-lg-flexAlignItemsTop' +
                (selectedSection === '#performance' ? ' is-selected' : '')
              }
            >
              <a
                href="#performance"
                onClick={onClickSection}
                data-analytics="simple-entry-component-body-subnav-tab-btn"
              >
                Performance
              </a>
            </li>
            <li
              className={
                'u-textSizeMsrp1 u-sm-paddingHoriz1gu u-paddingHoriz5gu u-textBold List-item u-sm-textSizeMsr u-sm-flex u-textCenter u-flexAlignItemsCenter u-sm-flexGrow1 u-lg-flexAlignItemsTop' +
                (selectedSection === '#prices-yields' ? ' is-selected' : '')
              }
            >
              <a
                href="#prices-yields"
                onClick={onClickSection}
                data-analytics="simple-entry-component-body-subnav-tab-btn"
              >
                Price &amp; Yields
              </a>
            </li>
            <li
              className={
                'u-textSizeMsrp1 u-sm-paddingHoriz1gu u-paddingHoriz5gu u-textBold List-item u-sm-textSizeMsr u-sm-flex u-textCenter u-flexAlignItemsCenter u-sm-flexGrow1 u-lg-flexAlignItemsTop' +
                (selectedSection === '#morningstar-ratings'
                  ? ' is-selected'
                  : '')
              }
            >
              <a
                href="#morningstar-ratings"
                onClick={onClickSection}
                data-analytics="simple-entry-component-body-subnav-tab-btn"
              >
                Morningstar Ratings
              </a>
            </li>
            {!ignoreClass && (
              <li
                className={
                  'u-textSizeMsrp1 u-sm-paddingHoriz1gu u-paddingHoriz5gu u-textBold List-item u-sm-textSizeMsr u-sm-flex u-textCenter u-flexAlignItemsCenter u-sm-flexGrow1 u-lg-flexAlignItemsTop' +
                  (selectedSection === '#capital-gains' ? ' is-selected' : '')
                }
              >
                <a
                  href="#capital-gains"
                  onClick={onClickSection}
                  data-analytics="simple-entry-component-body-subnav-tab-btn"
                >
                  Capital Gains
                </a>
              </li>
            )}
          </ul>
          <div>
            {isExpandable && (
              <div
                className="u-flex u-flexAlignItemsCenter"
                style={{ cursor: 'pointer' }}
                onClick={onClickExpandCollapse}
              >
                <span className="Icon--material">
                  {isExpanded ? 'unfold_less' : 'unfold_more'}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="u-paddingVert2gu u-bgColorLight">
        <div
          className={
            'u-sizeConstrained Card Content u-marginBottom10gu' +
            (ignoreClass ? '' : ' u-paddingBottom15gu')
          }
        >
          {/* FILTER / SEARCH */}
          <div className="u-bgColorLight">
            <FilterHeader
              placeholder={searchPlaceholder || 'Find a Mutual Fund'}
              count={selectedFilterCount}
              isOpen={isFilterOpen}
              onClick={onClickToggleFilter}
              onSearch={onChangeFundSearch}
            />
            <div className={isFilterOpen ? '' : 'u-hidden'}>
              <MutualFundsFilter
                selectedClass={selectedClass}
                ignoreClass={ignoreClass}
                strategyPlaceholder={strategyPlaceholder}
                onChange={onChangeFilter}
                onClose={onClickToggleFilter}
                onMorningstarChange={onChangeDisplayMorningstarCheckbox}
                onBenchmarkChange={onChangeDisplayBenchmarkCheckbox}
                onMorningStarGroupChange={
                  onChangeDisplayMorningstarGroupCheckbox
                }
                lookupCategory={lookupCategory}
                lookupIcon={lookupIcon}
                isETF={isETF}
              />
            </div>
          </div>
          {/* OPTIONS */}
          <div className="u-lg-flex u-lg-flexAlignItemsCenter u-flexJustifyBetween u-marginVert4gu u-flexWrap">
            {aspect.renderOptions()}
          </div>
          {selectedSection === '#performance' && (
            <div className="disclaimer u-marginVert4gu">
              <p>
                Performance data shown represents past performance and is not a
                guarantee of future results. The investment return and principal
                value of an investment will fluctuate so that shares, when
                redeemed, may be worth more or less than their original cost.
                Current performance may be lower or higher than the performance
                data shown. Returns shown assume reinvestment of distributions
                and do not reflect the deduction of taxes that a shareholder
                would pay on fund distributions or the redemption of fund
                shares.{' '}
                <span className="Link" onClick={onClickViewDisclosures}>
                  View disclosures
                </span>
              </p>
            </div>
          )}
          {/* STATUS / DOWNLOAD */}
          <div className="u-flex u-flexAlignItemsCenter u-marginTop2gu">
            <div className="Form-label u-flexAuto">
              Displaying{' '}
              <span className="u-textBold">
                {isFilterOn
                  ? (fundsFiltered && fundsFiltered.length) || 0
                  : (funds && funds.length) || 0}
              </span>{' '}
              fund(s)
            </div>
            {getDownload && (
              <div>
                <button
                  className="Button Button--secondary u-padding2gu u-textNoTransform"
                  onClick={onClickDownloadCSV}
                >
                  Download .CSV
                </button>
                |
                <button
                  className="Button Button--secondary u-padding2gu u-textNoTransform"
                  onClick={onClickDownloadTSV}
                >
                  Download .TSV
                </button>
              </div>
            )}
            {selectedSection === '#capital-gains' && getDownloadCapGains && (
              <div>
                <button
                  className="Button Button--secondary u-padding2gu u-textNoTransform"
                  onClick={(e) => onClickDownloadCapGains(e, 'productSummary')}
                  data-analytics="download-cap-gains-distributions-landing"
                >
                  Download Capital Gains Distributions (csv)
                </button>
                {isPresentFundEstimates(funds) && (
                  <>
                    {' '}
                    |{' '}
                    <button
                      className="Button Button--secondary u-padding2gu u-textNoTransform"
                      onClick={(e) => onClickDownloadCapGains(e, 'estimates')}
                      data-analytics="download-cap-gains-estimates-landing"
                    >
                      Download Capital Gains Estimates (csv)
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
          {/* TABLE */}
          {funds && !isDataLoading ? (
            <>
              <table
                className={
                  'Table Table--reversed Table--sortable u-sm-block u-overflowX'
                }
              >
                <thead role="rowgroup" className="Table-head">
                  <tr role="row" className="Table-row">
                    <th
                      colSpan={aspect.colSpan1}
                      className="Table-header u-bgColorBrand u-alignTop bordered"
                      role="columnheader"
                    ></th>
                    <th
                      colSpan={aspect.colSpan2}
                      className={`Table-header u-bgColorBrand u-padding2gu u-alignTop u-textNoWrap ${
                        aspect.colSpan3 && 'bordered'
                      }`}
                      role="columnheader"
                    >
                      {aspect.headerSummary1()}
                    </th>
                    {!useMorningstarGroup() && aspect.colSpan3 && (
                      <th
                        colSpan={aspect.colSpan3}
                        className="Table-header u-bgColorBrand u-padding2gu u-alignTop u-textNoWrap"
                        role="columnheader"
                      >
                        {aspect.headerSummary2()}
                      </th>
                    )}
                  </tr>
                  <tr role="row" className="Table-row">
                    {aspect.columns
                      .filter((column) => !column.hide)
                      .map((column) => renderColumnHeader(column))}
                  </tr>
                </thead>
                <tbody className="Table-body">
                  {(isFilterOn ? fundsFiltered : funds).length < 1 ? (
                    <tr className="Table-row">
                      <td className="Table-cell" colSpan={12}>
                        No matching funds found.
                      </td>
                    </tr>
                  ) : (
                    sortFunds(isFilterOn ? fundsFiltered : funds).map(
                      (fund) => {
                        // Morningstar Category
                        const showGroup =
                          fund.msCategoryName !== currentMorningstarCategory

                        currentMorningstarCategory =
                          fund.msCategoryName || fund.msCategory

                        const isDuplicate =
                          currentMorningstarCategory + fund.cusip === currentKey

                        currentKey = currentMorningstarCategory + fund.cusip

                        // Management Style
                        const showManagementStyleGroup =
                          fund.managementStyle != currentManagementStyle

                        currentManagementStyle = fund.managementStyle

                        const isManagementStyleDuplicate =
                          currentManagementStyle + fund.cusip ===
                          currentManagementStyleKey

                        currentManagementStyleKey =
                          currentManagementStyle + fund.cusip

                        const currentCollapsedManagementStyleSelected =
                          collapsedManagementStyleGroups.indexOf(
                            currentManagementStyle
                          ) < 0

                        if (isDuplicate || isManagementStyleDuplicate) {
                          return null
                        }

                        const jsx = (
                          <React.Fragment key={currentKey}>
                            {useMorningstarGroup() && showGroup ? (
                              <tr
                                className="Table-row-group u-borderColorNeutralLight u-borderTop u-borderBottom u-borderLeft0 u-borderRight0"
                                data-group={currentMorningstarCategory}
                                onClick={onClickToggleGroup}
                                data-qa-automation="morningstar-category-group"
                              >
                                {!aspect.columns[0].hide && (
                                  <td className="Table-cell"></td>
                                )}
                                <td className="Table-cell u-textCenter">
                                  <div
                                    className={
                                      'u-textSizeMsrp4' +
                                      (selectedGroups.indexOf(
                                        currentMorningstarCategory
                                      ) < 0
                                        ? ' Table-row-group-iconOpen'
                                        : '')
                                    }
                                  >
                                    {selectedGroups.indexOf(
                                      currentMorningstarCategory
                                    ) < 0
                                      ? '-'
                                      : '+'}
                                  </div>
                                </td>
                                <td className="Table-cell u-textBold">
                                  Morningstar Category:{' '}
                                  {currentMorningstarCategory}
                                </td>
                                <td className="Table-cell">
                                  {fund.overallFunds} Funds
                                </td>
                                <td className="Table-cell">
                                  {fund.threeYearFunds} Funds
                                </td>
                                <td className="Table-cell">
                                  {fund.fiveYearFunds} Funds
                                </td>
                                <td className="Table-cell">
                                  {fund.tenYearFunds} Funds
                                </td>
                              </tr>
                            ) : null}

                            {useManagementStyle() &&
                            showManagementStyleGroup ? (
                              <tr
                                className="Table-row-group u-borderColorNeutralLight u-borderTop u-borderBottom u-borderLeft0 u-borderRight0"
                                data-group={currentManagementStyle}
                                onClick={onClickToggleManagementStyleGroup}
                                data-qa-automation="management-style-group"
                              >
                                {!aspect.columns[0].hide && (
                                  <td className="Table-cell"></td>
                                )}
                                <td className="Table-cell u-textCenter">
                                  <div
                                    className={
                                      'u-textSizeMsrp4' +
                                      (currentCollapsedManagementStyleSelected
                                        ? ' Table-row-group-iconOpen'
                                        : '')
                                    }
                                  >
                                    {currentCollapsedManagementStyleSelected
                                      ? '-'
                                      : '+'}
                                  </div>
                                </td>
                                <td className="Table-cell u-textBold">
                                  Management Style: {currentManagementStyle}
                                </td>
                                {selectedSection === '#performance'
                                  ? renderEmptyTableData(10)
                                  : renderEmptyTableData(6)}
                              </tr>
                            ) : null}

                            {(!useMorningstarGroup() &&
                              !useManagementStyle()) ||
                            (selectedSection === '#morningstar-ratings' &&
                              selectedGroups.indexOf(
                                currentMorningstarCategory
                              ) < 0) ||
                            (selectedSection !== '#morningstar-ratings' &&
                              currentCollapsedManagementStyleSelected) ? (
                              <tr
                                className={
                                  'Table-row' +
                                  (currentStripe ? ' u-bgColorLight' : '')
                                }
                                role="row"
                              >
                                {aspect.columns
                                  .filter((column) => !column.hide)
                                  .map((column) =>
                                    renderColumnCell(column, fund)
                                  )}
                              </tr>
                            ) : null}

                            {useBenchmark() &&
                            currentCollapsedManagementStyleSelected ? (
                              <tr
                                className={
                                  currentStripe ? 'u-bgColorLight' : ''
                                }
                                data-qa-automation="primary-benchmark"
                              >
                                {!aspect.columns[0].hide && (
                                  <td className="Table-cell u-paddingRight2gu"></td>
                                )}
                                {!aspect.columns[1].hide && (
                                  <td className="Table-cell u-paddingRight2gu"></td>
                                )}
                                <td className="Table-cell u-paddingRight2gu">
                                  {fund.benchmarkName}
                                </td>
                                <td className="Table-cell u-paddingRight2gu bordered u-textRight">
                                  {fund.benchmarkYTD}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.benchmarkOneYear}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.benchmarkThreeYear}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.benchmarkFiveYear}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.benchmarkTenYear}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.benchmarkSinceInception}
                                </td>
                                <td className="Table-cell u-paddingRight2gu bordered"></td>
                                <td className="Table-cell u-paddingRight2gu"></td>
                                <td className="Table-cell u-paddingRight2gu"></td>
                              </tr>
                            ) : null}

                            {useMorningstarAverage() &&
                            currentCollapsedManagementStyleSelected &&
                            currentMorningstarCategory ? (
                              <tr
                                className={
                                  currentStripe ? 'u-bgColorLight' : ''
                                }
                                data-qa-automation="morningstar-category-average"
                              >
                                {!aspect.columns[0].hide && (
                                  <td className="Table-cell u-paddingRight2gu"></td>
                                )}
                                {!aspect.columns[1].hide && (
                                  <td className="Table-cell u-paddingRight2gu"></td>
                                )}
                                <td className="Table-cell u-paddingRight2gu">
                                  Morningstar Category:{' '}
                                  {currentMorningstarCategory}
                                </td>
                                <td className="Table-cell u-paddingRight2gu bordered u-textRight">
                                  {fund.msCategoryYTD}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.msCategoryOneYear || '-'}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.msCategoryThreeYear || '-'}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.msCategoryFiveYear || '-'}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.msCategoryTenYear || '-'}
                                </td>
                                <td className="Table-cell u-paddingRight2gu u-textRight">
                                  {fund.msCategoryInception || '-'}
                                </td>
                                <td className="Table-cell u-paddingRight2gu bordered"></td>
                                <td className="Table-cell u-paddingRight2gu"></td>
                                <td className="Table-cell u-paddingRight2gu"></td>
                              </tr>
                            ) : null}
                          </React.Fragment>
                        )

                        currentStripe = !currentStripe

                        return jsx
                      }
                    )
                  )}
                </tbody>
              </table>
              <div className="u-paddingTop10gu">
                {(isFilterOn ? fundsFiltered : funds).length < 1 && (
                  <p className="u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0 u-paddingTop4gu u-textPrimary u-marginHoriz3gu">
                    Not finding what you are looking for? Try another share
                    class (dropdown above) or{' '}
                    <a href={getRelativeBasePath() + '/search'}>
                      go to the Search page.
                    </a>
                  </p>
                )}
              </div>
            </>
          ) : (
            <Loader showBackground={false} />
          )}
        </div>
      </div>
      <div id="ampf-trace-loaded-page"></div>
    </>
  )
}
